import { II18nextTypes } from "common/src/types/i18n";
import { isNullOrUndefined } from "../utils/isNullOrUndefined";
import { IAddBookingObjType, ISettingsType, IUserType } from "common/src/types";


interface CreateBookingFirebaseNewProps {
    addBookingObj: IAddBookingObjType,
    settings: ISettingsType
}

interface CreateBookingFirebaseNewResponse {
    error?: boolean;
    msg?: keyof II18nextTypes;
    addBookingObj?: Partial<IAddBookingObjType>;
}

export const FormatBookingObjectNew = async ({ addBookingObj, settings }: CreateBookingFirebaseNewProps): Promise<CreateBookingFirebaseNewResponse> => {
    try {
        if (isNullOrUndefined(addBookingObj) || isNullOrUndefined(addBookingObj.pickup) || isNullOrUndefined(addBookingObj.pickup.coords) || isNullOrUndefined(addBookingObj.drop) || isNullOrUndefined(addBookingObj.drop.coords) || isNullOrUndefined(addBookingObj.carDetails) || isNullOrUndefined(addBookingObj.userDetails)) {
            return {
                error: true,
                msg: "no_details_error"
            }
        }

        const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        const reference = [...Array(6)].map(_ => c[~~(Math.random() * c.length)]).join('');

        let pickUp = { lat: addBookingObj.pickup.coords.lat, lng: addBookingObj.pickup.coords.lng, add: addBookingObj.pickup.description };
        let drop = { lat: addBookingObj.drop.coords.lat, lng: addBookingObj.drop.coords.lng, add: addBookingObj.drop.description };

        let coords = [{ latitude: pickUp.lat, longitude: pickUp.lng }];


        if (addBookingObj.drop.waypoints && Array.isArray(addBookingObj.drop.waypoints)) {
            addBookingObj.drop.waypoints.forEach((waypoint: any) => {
                if (waypoint.lat && waypoint.lng) {
                    coords.push({
                        latitude: waypoint.lat,
                        longitude: waypoint.lng
                    });
                } else if (waypoint.coords) {
                    coords.push({
                        latitude: waypoint.coords.lat,
                        longitude: waypoint.coords.lng
                    });
                }
            });
        } else if (addBookingObj.drop.waypointsStr) {
            if (addBookingObj.drop.waypointsStr.includes("|")) {

                addBookingObj.drop.waypointsStr.split("|").forEach((point: any) => {
                    let lat = point.split(',')[0];
                    let lng = point.split(',')[1];
                    coords.push({ latitude: lat, longitude: lng });
                });
            } else {
                let lat = addBookingObj.drop.waypointsStr.split(',')[0];
                let lng = addBookingObj.drop.waypointsStr.split(',')[1];
                coords.push({ latitude: Number(lat), longitude: Number(lng) });
            }
        }

        coords.push({ latitude: drop.lat, longitude: drop.lng });


        var otp;
        if (addBookingObj?.settings?.otp_secure)
            otp = Math.floor(Math.random() * 90000) + 10000;
        else {
            otp = false;
        }

        if (isNullOrUndefined(drop) || isNullOrUndefined(drop.add) || isNullOrUndefined(drop.lat) || isNullOrUndefined(drop.lng) || isNullOrUndefined(pickUp) || isNullOrUndefined(pickUp.add) || isNullOrUndefined(pickUp.lat) || isNullOrUndefined(pickUp.lng)) {
            return {
                error: true,
                msg: "no_details_error"
            }
        }


        const driver: IUserType = (addBookingObj as any)?.drivers[0]


        let bookingObj: any = {};

        const isCashSubPayment = addBookingObj.payment_mode == "driver_pix" || addBookingObj.payment_mode == "driver_credit_card" || addBookingObj.payment_mode == "driver_debit_card"


        bookingObj = {
            otp: otp,
            drop: drop,
            status: "NEW",
            coords: coords,
            pickup: pickUp,
            reference: reference,
            tripdate: new Date().getTime(),
            estimate: addBookingObj.estimate,
            bookingDate: new Date().getTime(),
            isTaximeter: addBookingObj.isTaximeter,
            carType: addBookingObj.carDetails.name,
            real_payment_mode: addBookingObj.payment_mode,
            trip_cost: addBookingObj.estimate.estimateFare,
            carImage: addBookingObj.carDetails.image || null,
            passengerRating: addBookingObj.userDetails.rating,
            customer_email: addBookingObj.userDetails.email || null,
            estimateTime: String(addBookingObj.estimate.estimateTime),
            convenience_fees: addBookingObj.estimate.convenience_fees,
            distance: String(addBookingObj.estimate.estimateDistance),
            routeDetails: addBookingObj.estimate.routeDetails || null,
            customer_token: addBookingObj.userDetails.pushToken || null,
            commission_type: addBookingObj.carDetails.convenience_fee_type,
            commission_rate: String(addBookingObj.carDetails.convenience_fees),
            payment_mode: isCashSubPayment ? "cash" : addBookingObj.payment_mode,
            fleetadmin: addBookingObj.fleetadmin ? addBookingObj.fleetadmin : null,
            waypoints: addBookingObj.drop.waypoints ? addBookingObj.drop.waypoints : null,
            customer: addBookingObj.userDetails.id || addBookingObj.userDetails.uid || null,
            paymentPacket: addBookingObj.paymentPacket ? addBookingObj.paymentPacket : null,
            driverEstimates: addBookingObj.driverEstimates ? addBookingObj.driverEstimates : null,
            requestedDrivers: addBookingObj.requestedDrivers ? addBookingObj.requestedDrivers : null,
            booking_from_web: addBookingObj.booking_from_web ? addBookingObj.booking_from_web : false,
            customer_contact: addBookingObj.userDetails.mobile ? addBookingObj.userDetails.mobile : null,
            customer_name: addBookingObj.userDetails.firstName + ' ' + addBookingObj.userDetails.lastName,
            customer_image: addBookingObj.userDetails.profile_image ? addBookingObj.userDetails.profile_image : "",
            driver_share: (parseFloat(String(addBookingObj.estimate.estimateFare)) - parseFloat(String(addBookingObj.estimate.convenience_fees))).toFixed(settings.decimal),
        };

        if (addBookingObj.isTaximeter && driver) {
            Object.assign(bookingObj, {
                status: "ACCEPTED",
                driver: driver.id ? driver.id : null,
                driverRating: driver.rating ? driver.rating : "0",
                driver_contact: driver.mobile ? driver.mobile : '',
                car_image: driver.car_image ? driver.car_image : "",
                driver_name: driver.firstName + " " + driver.lastName,
                driver_token: driver.pushToken ? driver.pushToken : '',
                fleetadmin: driver.fleetadmin ? driver.fleetadmin : "",
                other_info: driver.other_info ? driver.other_info : "",
                vehicle_year: driver.vehicleYear ? driver.vehicleYear : "",
                vehicle_model: driver.vehicleModel ? driver.vehicleModel : "",
                vehicle_number: driver.vehicleNumber ? driver.vehicleNumber : "",
                driver_image: driver.profile_image ? driver.profile_image : "",
                driverDeviceId: driver.currentDeviceId ? driver.currentDeviceId : null,
            });
        }

        return {
            addBookingObj: bookingObj
        };

    } catch (error) {
        console.error(error)
        return {
            error: true,
            msg: error as any
        };
    }
}
